// Lengths are kept in whole millimetres everywhere; these convert to and from
// what people type and read. "ft" shows feet and inches, "m" metres or mm.

export const MM_PER_INCH = 25.4;

export function formatLength(mm, units = "ft") {
  if (mm == null || mm === "" || Number.isNaN(Number(mm))) return "";
  const value = Number(mm);
  if (units === "m") return value >= 1000 ? `${(value / 1000).toFixed(2)} m` : `${Math.round(value)} mm`;
  const halfInches = Math.round((value / MM_PER_INCH) * 2) / 2;
  const feet = Math.floor(halfInches / 12);
  const inches = halfInches - feet * 12;
  if (feet && inches) return `${feet}' ${inches}"`;
  return feet ? `${feet}'` : `${inches}"`;
}

export const formatSize = (w, h, units) => (w && h ? `${formatLength(w, units)} × ${formatLength(h, units)}` : "");

// Accepts 12' 6", 12'6, 12 ft 6 in, 12.5 ft, 150", 150 in, 3.6 m, 360 cm,
// 3600 mm, or a bare number in the default unit (feet or metres).
export function parseLength(text, units = "ft") {
  if (text == null) return null;
  const raw = String(text).trim().toLowerCase().replace(/,/g, "");
  if (!raw) return null;
  const number = "(\\d+(?:\\.\\d+)?|\\.\\d+)";
  const feetInches = raw.match(new RegExp(`^${number}\\s*(?:'|ft|feet|foot)\\s*(?:${number}\\s*(?:"|''|in|inch|inches)?)?$`));
  if (feetInches) {
    return Math.round((Number(feetInches[1]) * 12 + Number(feetInches[2] || 0)) * MM_PER_INCH);
  }
  const single = raw.match(new RegExp(`^${number}\\s*("|''|in|inch|inches|mm|cm|m|metres?|meters?)?$`));
  if (!single) return null;
  const value = Number(single[1]);
  const unit = single[2] || (units === "m" ? "m" : "ft");
  const factor = {
    '"': MM_PER_INCH,
    "''": MM_PER_INCH,
    in: MM_PER_INCH,
    inch: MM_PER_INCH,
    inches: MM_PER_INCH,
    ft: 12 * MM_PER_INCH,
    mm: 1,
    cm: 10,
    m: 1000,
    metre: 1000,
    metres: 1000,
    meter: 1000,
    meters: 1000,
  }[unit];
  const mm = Math.round(value * factor);
  return mm > 0 ? mm : null;
}

export const formatMoney = (value) =>
  value == null
    ? "—"
    : Number(value).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
